import { RegisterInviteForm } from "~/features/register-invite/ui/register-invite.form";

export const RegisterInvitePage = () => {
  return (
    <div className=" flex items-center justify-center dark:bg-gray-900 p-2 sm:p-4">
      <RegisterInviteForm />
    </div>
  );
};
